const EMPTY = '—';

function toDate(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Locale-aware date + time ("24 oct 2026, 6:41 p. m." / "Oct 24, 2026, 6:41 PM").
 * Pass `i18n.language` as `locale` so the output follows the UI language
 * instead of the browser's or a hardcoded one.
 */
export function formatDateTime(
  value: string | number | Date | null | undefined,
  locale: string,
  timeZone?: string,
): string {
  const d = toDate(value);
  if (!d) return EMPTY;
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone,
  }).format(d);
}

/** Locale-aware date only. */
export function formatDate(
  value: string | number | Date | null | undefined,
  locale: string,
  timeZone?: string,
): string {
  const d = toDate(value);
  if (!d) return EMPTY;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone }).format(d);
}
